import {
  Grid,
  CardHeader,
  CardContent,
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useState, useEffect, useCallback } from "react";
import { apiCategory, AuctionServices } from "../../services/AllServices";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import errorHandler from "../../utils/errorHandler";
import LoadingButton from "@mui/lab/LoadingButton";
import { AuctionSchema } from "../../utils/Schema";
import CardLayout from "../../layouts/CardLayout";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { capitalizeFirstLetter } from "../../utils/helpers";

function AddEditAuction() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [ticket, setticket] = useState([]);
  const [selectticket, setSelectticket] = useState([]);
  const [categories, setCategories] = useState([]);

  const { id } = useParams();

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await AuctionServices.getById({ id });
        const resData = response?.data?.data;
        setSelectticket(resData.ticket);
        setData(resData);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchTaskData();
    fetchCategoriesData();
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: AuctionSchema,
    // initialValues: {
    //   slug: data?.category[0].slug || "",
    //   ticket: selectticket || [],
    //   startDate: data?.startDate ? dayjs(data.startDate) : null,
    //   endDate: data?.endDate ? dayjs(data.endDate) : null,
    //   status: "active",
    // },
    initialValues: {
      slug: data?.category?.[0]?.slug || "",
      ticket: selectticket?.map((t) => t._id) || [], // array of strings
      startDate: data?.startDate ? dayjs(data?.startDate) : null,
      endDate: data?.endDate ? dayjs(data?.endDate) : null,
      status: "active",
    },

    onSubmit: async (values) => {
      // setLoading(true);
      try {
        const payload = {
          ...values,
        };
        if (id) payload["id"] = id;

        const response = id
          ? await AuctionServices.edit(payload)
          : await AuctionServices.add(payload);

        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        console.error(error);
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCategoryChange = async (event) => {
    const category = event.target.value;
    formik.setFieldValue("slug", category);
    formik.setFieldTouched("slug", true, false);
    formik.setFieldValue("ticket", []);
    setTimeout(() => formik.validateForm(), 0);

    const payload = {
      slug: category,
    };
    try {
      const response = await AuctionServices.allTickets(payload);
      const ticketData = response?.data?.data || [];
      setticket(ticketData);

      if (id) {
        const selectedTickets =
          response?.data?.data?.filter((ticket) =>
            formik.values.ticket.includes(ticket._id)
          ) || [];
        formik.setFieldValue(
          "ticket",
          selectedTickets.map((ticket) => ticket._id)
        );
      }
    } catch (error) {
      setticket([]);
      errorHandler(error);
    }
  };
  const fetchCategoriesData = async (req, res) => {
    try {
      const response = await apiCategory.category();
      setCategories(response?.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    const fetchCategoryIfSlugExists = async () => {
      if (formik.values.slug) {
        try {
          const payload = { slug: formik.values.slug };
          const response = await AuctionServices.allTickets(payload);
          const ticketData = response.data?.data || [];
          setticket(ticketData);
        } catch (error) {
          setticket([]);
          errorHandler(error);
        }
      }
    };

    fetchCategoryIfSlugExists();
  }, [formik.values.slug]);

  const handleTicketToggle = (ticketId) => {
    const selectedTickets = formik.values.ticket;
    if (selectedTickets.includes(ticketId)) {
      formik.setFieldValue(
        "ticket",
        selectedTickets.filter((id) => id !== ticketId)
      );
    } else {
      formik.setFieldValue("ticket", [...selectedTickets, ticketId]);
    }
  };
  return (
    <Box>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} Auction`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Select Category"
                    value={formik.values.slug}
                    onChange={handleCategoryChange}
                    name="slug"
                    error={Boolean(formik.touched.slug && formik.errors.slug)}
                    helperText={formik.touched.slug && formik.errors.slug}
                  >
                    <MenuItem value="" disabled>
                      Select Category
                    </MenuItem>
                    {categories &&
                    Array.isArray(categories) &&
                    categories.length > 0
                      ? categories.map((item, index) => (
                          <MenuItem value={item.slug}>{item.name}</MenuItem>
                        ))
                      : "Category Not Available"}
                  </TextField>
                </Grid>

                <Grid item xs={6} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Tickets</InputLabel>
                    <Select
                      value={formik?.values?.ticket?.[0] || ""} // store first item for UI
                      onChange={(event) => {
                        const selectedValue = event.target.value;
                        formik.setFieldValue(
                          "ticket",
                          selectedValue ? [selectedValue] : []
                        ); // always array
                      }}
                      input={<OutlinedInput label="Tickets" />}
                      renderValue={(selected) => {
                        const t = ticket.find((t) => t._id === selected);
                        return t ? t.name : "";
                      }}
                    >
                      {ticket?.map((sub) => (
                        <MenuItem key={sub._id} value={sub._id}>
                          {sub.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["MobileTimePicker"]}>
                      <MobileDateTimePicker
                        className="custom-time-field"
                        label="Start Date & Time"
                        value={formik?.values?.startDate}
                        onChange={(newValue) =>
                          formik.setFieldValue("startDate", newValue)
                        }
                        slots={{
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={Boolean(
                                formik.touched.startDate &&
                                  formik.errors.startDate
                              )}
                              helperText={
                                formik.touched.startDate &&
                                formik.errors.startDate
                              }
                            />
                          ),
                        }}
                        inputFormat="MM/dd/yyyy hh:mm a"
                        ampm
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={6} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["MobileTimePicker"]}>
                      <MobileDateTimePicker
                        className="custom-time-field"
                        label="End Date & Time"
                        value={formik?.values?.endDate}
                        onChange={(newValue) =>
                          formik.setFieldValue("endDate", newValue)
                        }
                        slots={{
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={Boolean(
                                formik.touched.endDate && formik.errors.endDate
                              )} // Adds red border
                              helperText={
                                formik.touched.endDate && formik.errors.endDate
                              } // Shows error message
                            />
                          ),
                        }}
                        inputFormat="MM/dd/yyyy hh:mm a"
                        ampm
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mt={3}>
                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {id ? "Update" : "Add"} Auction
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditAuction;
